import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../shared/services/api.service';
import { Application } from '../model/application';

const HOSTNAME_O3 = environment.api.o3;

@Injectable({
  providedIn: 'root',
})
export class ApplicationsService {
  constructor(private apiService: ApiService) {}

  getApplications(): Observable<Application[]> {
    return this.apiService.get<Application[]>('applications', HOSTNAME_O3);
  }

  isValidApplication(normalizedAppName: string): Observable<boolean> {
    return this.getApplications().pipe(
      map((apps) => apps.some((app) => app.applicationId === normalizedAppName))
    );
  }

  filterValidApplications(appNames: string[]): Observable<string[]> {
    return this.getApplications().pipe(
      map((apps) => {
        const validApps = new Set(apps.map((app) => app.applicationId));
        return appNames.filter((name) => validApps.has(name));
      })
    );
  }
}
